module.exports = __webpack_public_path__ + "img/full5-min.586fe266.png";